import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";
import React from "react";

export const BigDataOutlinedIcon = ({
  width = "24",
  height = "24",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 11.5791V16.6317C5 18.0271 8.01642 19.158 11.7368 19.158C11.8766 19.158 12.0156 19.1564 12.1537 19.153"
          stroke="#2194D2"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 6.52637V11.579C5 12.9744 8.01642 14.1053 11.7368 14.1053C12.6421 14.1053 13.5053 14.0379 14.2943 13.9167M18.4737 11.579V6.52637"
          stroke="#0860A8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 6.52632C5 7.92168 8.01642 9.05263 11.7368 9.05263C15.4573 9.05263 18.4737 7.92168 18.4737 6.52632C18.4737 5.13095 15.4573 4 11.7368 4C8.01642 4 5 5.13095 5 6.52632Z"
          stroke="#1C3C6C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 17.5263H20.0526M17.5263 15V20.0526"
          stroke="#1C3C6C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  );
};
